import { connect } from 'react-redux';
import { compose } from 'redux';
import _range from 'lodash/range';
import { withOpportunityShownTracking } from 'helpers/events';

import SpotRow from './SpotRow';

const mapStateToProps = (_, ownProps) => {
  const { opportunity } = ownProps;
  const { networkSpotsAllocated, recommendation, totalCapacity, totalReservations } = opportunity;

  // Calculate available capacity based on total capacity minus existing reservations
  // This applies to both traditional and SmartSpot opportunities
  const availabilityDropdownRange = _range(
    1,
    (totalCapacity || networkSpotsAllocated + recommendation) - (totalReservations || 0) + 1
  );

  return {
    availabilityDropdownRange,
  };
};

export default compose(withOpportunityShownTracking, connect(mapStateToProps))(SpotRow);
